<template>
  <div class="documents">
    <div
      class="col-36"
      v-if="meta.attestationPiecesJustificatives?.$status === PropertyStatus.Required"
    >
      <WrapperCheckbox
        id="field_attestationPiecesJustificatives"
        v-model="attestationPiecesJustificativesModel"
        :alertLabel="meta.attestationPiecesJustificatives?.$messageErreurDirty!"
        label="L'employeur atteste disposer de l'ensemble des pièces justificatives nécessaires au dépôt du dossier"
        :readonly
        class="wrapper-width-fit wrapper-without-margin-top"
      />
    </div>
    <UploadFichiers>
      <template #footer-nature="item">
        <BasicAlert
          v-if="item?.code === 'AttestationEmployeur'"
          :alertLabel="ATTESTATION_EMPLOYEUR_TOOLTIP"
          alert-type="info"
        />
      </template>
    </UploadFichiers>
  </div>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { UploadFichiers } from '@/features/interface/demande/shared/components'
  import { storeToRefs } from 'pinia'
  import { useDemandeOutilFPEStore } from '../../useDemandeOutilFPEStore.ts'

  const ATTESTATION_EMPLOYEUR_TOOLTIP =
    "Attestation de l'employeur précisant le montant remboursé au salarié correspondant au montant de la facture prestataire"

  const store = useDemandeOutilFPEStore()
  const { setupFieldWithKey } = useDemandeOutilFPEStore()

  const { meta, readonly } = storeToRefs(store)

  const attestationPiecesJustificativesModel = setupFieldWithKey<boolean>('attestationPiecesJustificatives', true)
</script>

<style scoped lang="less">
  .documents {
    display: flex;
    flex-direction: column;
    gap: @spacing-25;

    &__section {
      display: flex;
      flex-direction: column;
      gap: @spacing-15;

      &__button {
        width: 500px;
      }
    }
  }
</style>
